// Select.jsx
import React from 'react';

const Select = ({ value, onChange, options, placeholder, disabled }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="border p-4 text-base border-primary-500 bg-white text-black focus:outline-none w-full h-14 rounded-none"
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
